import { Grid } from '@domain-group/suit-theme'

import { CampaignComparableModel } from '@models/types'

import CampaignComparableGridItem from '../../CampaignComparableGridItem'

type GridViewProps = {
  campaignComparables: CampaignComparableModel[],
}

const GridView = (props: GridViewProps) => {
  const { campaignComparables } = props

  return (
    <Grid
      // @ts-expect-error TS2322
      gridAutoRows="1fr"
      gridGap="large"
      gridRowGap="medium"
      gridTemplateColumns="repeat(auto-fill, minmax(280px, 1fr))"
      gridTemplateRows="repeat(auto-fill)"
      justifyContent={['center', 'flex-start']}
      padding="large"
    >
      {campaignComparables.map(campaignComparable => (
        <CampaignComparableGridItem
          campaignComparable={campaignComparable}
          key={campaignComparable.id}
        />
      ))}
    </Grid>
  )
}

export default GridView
